/**
 * Extracts one or two letters from full name.
 * If name is one word, returns first letter of this word.
 * If name is two words, returns first letter of each word.
 * 
 * @param {string} name 
 * @returns {string}
 */
export const lettersFromFullName = (name) => {
  const words = name.split(' ');
  if (words.length === 1) {
    return words[0].charAt(0);
  }
  return words[0].charAt(0) + words[1].charAt(0);
};
